import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiUpdateLiveStreamRequestBody,
  IApiUpdateLiveStreamResponseBody,
} from '../LiveStreamsApi.types';
import { useApi } from '~/lib/api/useApi';
import { liveStreamQueryKeyFactory } from './useLiveStreamQuery';
import { liveStreamsQueryKeyFactory } from './useLiveStreamsQuery';

export type IUseUpdateLiveStreamMutationValues = {
  appId: string;
  liveStreamId: string;
  body: IApiUpdateLiveStreamRequestBody;
};

export const useUpdateLiveStreamMutation = (): UseMutationResult<
  IApiUpdateLiveStreamResponseBody,
  unknown,
  IUseUpdateLiveStreamMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) =>
      api.liveStreams.update(values.appId, values.liveStreamId, values.body),
    onSuccess: async (updatedLiveStream, values) => {
      queryClient.setQueryData(
        liveStreamQueryKeyFactory({
          ...values,
          liveStreamId: updatedLiveStream._id,
        })!,
        updatedLiveStream,
      );
      await queryClient.invalidateQueries({
        queryKey: liveStreamsQueryKeyFactory(),
      });
    },
  });
};
